<template>
  <thead>
    <tr role="row">
      <td v-if="showCheckbox" class="pseudo-th" style="width:32px">
        <input
          v-model="checked"
          aria-label="Zaznacz wszystkie wiersze"
          type="checkbox"
          @change="$emit('checkAll', checked)"
        />
      </td>

      <th
        v-for="(column, index) in columns"
        :key="'th_' + index"
        :ref="'column_header_' + index"
        :tabindex="column.sortable ? 0 : undefined"
        :style="columnStyle(column, $refs['column_header_' + index])"
        :title="column.sortable ? 'Sortuj' : ''"
        :class="column.headerCssClass"
        @click="setOrder(column)"
        @keydown="keydownHandler('setOrder', column)"
      >
        <span>
          {{ column.displayName }}
          <i
            v-if="column.sortBy ? column.sortBy === sort.order : column.name === sort.order"
            class="fal fa-fw"
            :class="{ 'fa-arrow-down': !sort.desc, 'fa-arrow-up': sort.desc }"
          />
        </span>
      </th>

      <th v-if="actions.length > 0" width="1px">
        <span class="sr-only">Akcje</span>
      </th>
    </tr>

    <tr v-if="showColumnNumbers" role="row" class="non-sticky-th">
      <td v-if="showCheckbox" />

      <th
        v-for="(column, index) in columns"
        :key="'th_number_' + index"
        :ref="'column_number_' + index"
        :class="column.headerCssClass"
        :style="columnStyle(column, $refs['column_number_' + index])"
      >
        {{ index + 1 }}
      </th>

      <th v-if="actions.length > 0" />
    </tr>
  </thead>
</template>

<script>
import { keyboardMixin } from '@/mixins/keyboard';
import { getColumnOffset } from '@/utils/getColumnOffset';

// @vuese
// Header tabeli
// @group Table
export default {
  name: 'THead',
  mixins: [keyboardMixin],
  props: {
    // Kolumny tabeli
    columns: { type: Array, required: true },
    // Możliwe akcje
    actions: { type: Array, required: false },
    // Sortowanie tabeli
    sort: { type: Object, required: false, default: () => ({ order: 'name', desc: true }) },
    // Edytowanie wielu
    showCheckbox: { type: Boolean, required: true },
    // Początkowa wartość zaznaczenia
    initialChecked: { type: Boolean, required: false, default: false },
    // Czy pokazywać numery kolumn
    showColumnNumbers: { type: Boolean, default: false }
  },
  data() {
    return { checked: this.initialChecked, mounted: false };
  },
  watch: {
    showCheckbox(val) {
      if (!val) {
        this.checked = false;
      }
    },
    $route() {
      this.checked = false;
    }
  },
  mounted() {
    this.$nextTick().then(() => (this.mounted = !this.mounted));
  },
  methods: {
    // @vuese
    // Ustawianie sortowania tabeli
    setOrder(column) {
      if (column.sortable) {
        const desc = this.sort.order === (column.sortBy ?? column.name) ? !this.sort.desc : true;
        this.$emit('order', { order: column.sortBy ?? column.name, desc: typeof desc === 'boolean' ? desc : true });
      }
    },

    // @vuese
    // Zwraca odległość od lewej strony tabeli
    getOffset(element) {
      this.mounted;
      if (element?.[0]?.classList.contains('sticky-left')) {
        const offset = getColumnOffset(element[0]) + 'px';
        return offset;
      }
    },

    // @vuese
    // Zwraca style kolumny
    columnStyle(column, element) {
      return {
        'max-width': column.maxWidth,
        'min-width': column.width,
        width: column.width,
        cursor: column.sortable ? 'pointer' : 'default',
        left: this.getOffset(element)
      };
    }
  }
};
</script>
